export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./link-info.vue?vue&type=template&id=5825ad16"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/link/link-info.vue?vue&type=template&id=5825ad16
// module id = B0uW
// module chunks = 0